import React from 'react'
import './index.css'
import FlexColumn from 'components/FlexColumn'
import Image from 'components/Image'
import Span from 'components/Span'
import B from 'components/B'
import View from 'components/View'
import ButtonLink from 'components/ButtonLink'
import TikTokIcon from 'components/Icons/TikTok'
import InstagramIcon from 'components/Icons/Instagram'
import SnapchatIcon from 'components/Icons/Snapchat'
import logEventWithPrefixAnalyticsUtil from 'utils/analytics/log-event-with-prefix'

const ANALYTICS_EVENT = {
  VIEW_INFLUENCER_INTAGRAM: 'VIEW_INFLUENCER_INTAGRAM',
  VIEW_INFLUENCER_SNAPCHAT: 'VIEW_INFLUENCER_SNAPCHAT',
  VIEW_INFLUENCER_TIK_TOK: 'VIEW_INFLUENCER_TIK_TOK'
}

/**
 * @param props
 * @param {InfluencerInfo} props.influencerInfo
 * @param {string} props.analyticEventPrefix
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarInfluencerCard (props) {
  const {
    influencerInfo,
    analyticEventPrefix
  } = props
  const image = influencerInfo.profile_pic_url
  const name = influencerInfo.full_name
  const message = influencerInfo.message
  const tiktokUsername = influencerInfo.tiktok_username
  const instagramUsername = influencerInfo.instagram_username
  const snapchatUsername = influencerInfo.snapchat_username

  const logEvent = (event) => {
    return logEventWithPrefixAnalyticsUtil(analyticEventPrefix, event)
  }
  const handleClickTikTok = () => {
    logEvent(ANALYTICS_EVENT.VIEW_INFLUENCER_TIK_TOK)
  }

  const handleClickInstagram = () => {
    logEvent(ANALYTICS_EVENT.VIEW_INFLUENCER_INTAGRAM)
  }

  const handleClickSnapchat = () => {
    logEvent(ANALYTICS_EVENT.VIEW_INFLUENCER_SNAPCHAT)
  }

  return (
    <FlexColumn
      className='quick-shop-product-sidebar-influencer-card'
    >
      <Image
        src={image}
        srcSet={image}
        alt='influencer'
        shouldLazyLoad
      />

      <Span
        className='quick-shop-product-sidebar-influencer-card-name'
      >
        <B>{name}</B>
      </Span>

      <Span
        className='quick-shop-product-sidebar-influencer-card-message'
      >
        “{message}”
      </Span>

      <View
        className='quick-shop-product-sidebar-influencer-card-social'
      >
        {
          !!tiktokUsername && (
            <ButtonLink
              className='quick-shop-product-sidebar-influencer-card-social-item'
              href={`https://www.tiktok.com/@${tiktokUsername}`}
              onClick={handleClickTikTok}
              target='_blank'
            >
              <TikTokIcon />
              @{tiktokUsername}
            </ButtonLink>
          )
        }

        {
          !!instagramUsername && (
            <ButtonLink
              className='quick-shop-product-sidebar-influencer-card-social-item'
              href={`https://www.instagram.com/${instagramUsername}`}
              onClick={handleClickInstagram}
              target='_blank'
            >
              <InstagramIcon />
              @{instagramUsername}
            </ButtonLink>
          )
        }
      </View>

      {
        !!snapchatUsername && (
          <ButtonLink
            className='quick-shop-product-sidebar-influencer-card-social-item'
            data-social='snapchat'
            href={`https://www.snapchat.com/add/${snapchatUsername}`}
            onClick={handleClickSnapchat}
            target='_blank'
          >
            <SnapchatIcon />
            @{snapchatUsername}
          </ButtonLink>
        )
      }
    </FlexColumn>
  )
}
